var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
import { GrindingOption, isAllowedAdditionalProcess, } from "../utilities/articleeditdata";
let GrindingDropDown = class GrindingDropDown extends Vue {
    constructor() {
        super(...arguments);
        this.selectedIndex = 0;
    }
    grindingChange(e) { return e; }
    onChange(event) {
        this.selectedIndex = event.target.selectedIndex;
        return this.grindingChange(this.grindingMap[this.selectedIndex].value);
    }
    priceDifference(price) { return price - this.currentPrice; }
    grindingString(option, price) {
        return price === 0
            ? option
            : option + " (" + (price >= 0. ? "+" : "") + this.i18n.currencyString(price / this.multiplicity, this.networkBroker.configuration.priceFactors) + " " + this.i18n.t("perUnit") + ")";
    }
    get elementKey() { return "mechanicalGrinding"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    get currentPrice() {
        if (this.rowDataValue === undefined) {
            throw Error("currentPrice(): Missing current value");
        }
        return this.prices[this.rowDataValue];
    }
    get grindingMap() {
        const map = [
            {
                value: GrindingOption.none,
                str: this.grindingString(this.i18n.t("noGrinding")
                    .toString(), this.priceDifference(0)),
            },
        ];
        if (!isAllowedAdditionalProcess("mechanicalGrinding", this.shopConfig)) {
            throw Error("No process allowed.");
        }
        if (this.shopConfig.allowedAdditionalProcesses.some(p => p === "mechanicalDeburring")) {
            map.push({
                value: GrindingOption.singleSidedMechanicalDeburring,
                str: this.grindingString(this.i18n.t("bottomMechanicalDeburring")
                    .toString(), this.priceDifference(this.prices[GrindingOption.singleSidedMechanicalDeburring])),
            });
            map.push({
                value: GrindingOption.doubleSidedMechanicalDeburring,
                str: this.grindingString(this.i18n.t("doubleSidedMechanicalDeburring")
                    .toString(), this.priceDifference(this.prices[GrindingOption.doubleSidedMechanicalDeburring])),
            });
        }
        if (this.shopConfig.allowedAdditionalProcesses.some(p => p === "slideGrinding")) {
            map.push({
                value: GrindingOption.slideGrinding,
                str: this.grindingString(this.i18n.t("slideGrinding")
                    .toString(), this.priceDifference(this.prices[GrindingOption.slideGrinding])),
            });
        }
        if (map.length < 2) {
            throw Error("At least one option has to be added.");
        }
        return map;
    }
    created() { this.selectedIndex = this.grindingMap.findIndex(e => e.value === this.value); }
    onValueChanged(val, _oldVal) { this.selectedIndex = this.grindingMap.findIndex(e => e.value === val); }
};
__decorate([
    Prop({ required: true })
], GrindingDropDown.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], GrindingDropDown.prototype, "multiplicity", void 0);
__decorate([
    Prop({ required: true })
], GrindingDropDown.prototype, "prices", void 0);
__decorate([
    Prop({ required: true })
], GrindingDropDown.prototype, "rowDataValue", void 0);
__decorate([
    Prop({ required: true })
], GrindingDropDown.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], GrindingDropDown.prototype, "value", void 0);
__decorate([
    Inject()
], GrindingDropDown.prototype, "i18n", void 0);
__decorate([
    Inject()
], GrindingDropDown.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], GrindingDropDown.prototype, "grindingChange", null);
__decorate([
    Watch("value")
], GrindingDropDown.prototype, "onValueChanged", null);
GrindingDropDown = __decorate([
    Component({
        components: {
            EditDataElementLabel,
        },
        name: "GrindingDropDown",
    })
], GrindingDropDown);
export default GrindingDropDown;
